import ChargeTransactionListView from '../../components/ChargeTransactionListView';

function ChargeTransactionListScreen(props) {
  return (
    <div className="container-fluid px-4 my-4">
      <ChargeTransactionListView />
    </div>
  );
}

export default ChargeTransactionListScreen;
